
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
  }
})
export default class ContinueShoppingModal extends Vue {
  @Prop() isMobile!: boolean;
  @Prop({ default: '' }) message!: string;
  @Prop({ default: 'Nope, Back To Menu', type: String }) continueLabel!: string;
  name = 'ContinueShoppingModal';

  data() {
    return {
    }
  }

  @Emit('close')
  close(event) {
    return event;
  }
}
